import { apiService } from './apiService';

apiService.enhanceEndpoints({
  endpoints: {
    campaignControllerCampaign: {
      providesTags: (_result, _error, arg) => [{ type: 'Campaign', id: arg.id }],
    },
    handoffRuleCreateControllerExecute: {
      invalidatesTags: [{ type: 'Campaign' }],
    },
  },
});

export { apiService };
